/*ěščřžýáíéúů*/
(function ($) {

	// ── Thumbs slider (inicializovat první – main slider se na něj odkazuje) ────

	var thumbsSwiper = null;

	if ( $( '.product-gallery-thumbs .swiper-slide' ).length ) {
		thumbsSwiper = new Swiper( '.product-gallery-thumbs', {
			slidesPerView: 5,
			spaceBetween: 4,
			watchSlidesProgress: true,
			freeMode: true,
		} );
	}

	// ── Main gallery slider ───────────────────────────────────────────────────

	var mainSwiper = null;

	if ( $( '.product-gallery-slider .swiper-slide' ).length ) {
		// Staré (živé) šipky jsou uvnitř .product-gallery-slider. V novém designu
		// (admin-only) jsou přesunuté ven, vedle náhledů (.produkt-v2__gallery-nav),
		// aby je overflow:hidden slideru neořezával — fallback na ně, jen když
		// je uvnitř slideru nenajdeme.
		var $mainPrev = $( '.product-gallery-slider .swiper-button-prev' );
		var $mainNext = $( '.product-gallery-slider .swiper-button-next' );

		if ( ! $mainPrev.length ) {
			$mainPrev = $( '.produkt-v2__gallery-nav .swiper-button-prev' );
			$mainNext = $( '.produkt-v2__gallery-nav .swiper-button-next' );
		}

		mainSwiper = new Swiper( '.product-gallery-slider', {
			slidesPerView: 1,
			loop: true,
			navigation: {
				prevEl: $mainPrev[ 0 ],
				nextEl: $mainNext[ 0 ],
			},
			thumbs: {
				swiper: thumbsSwiper,
			},
		} );
	}

	// ── Mobile gallery slider ─────────────────────────────────────────────────

	if ( $( '.product-gallery-slider-mobile .swiper-slide' ).length ) {
		new Swiper( '.product-gallery-slider-mobile', {
			slidesPerView: 1,
			loop: true,
			navigation: {
				prevEl: '.product-gallery-slider-mobile .swiper-button-prev',
				nextEl: '.product-gallery-slider-mobile .swiper-button-next',
			},
		} );
	}

	// ── Logos carousel (desktop + mobile – každý inicializovat samostatně) ────
	// V novém designu (.produkt-v2__logos-wrap, admin-only) je to plynulá
	// nekonečná marquee animace (CSS), ne diskrétní swiper snímky — ty i s
	// autoplay dělaly znatelné pauzy/skoky. Slidy se pro plynulou smyčku
	// zdvojí a o zbytek se postará @keyframes v single-produkt-v2.scss.
	// Staré (živé) .after-gallery-section beze změny — pořád swiper se šipkami.

	$( '.after-gallery-section .logos-items.swiper' ).each( function () {
		var $swiper = $( this );

		if ( $swiper.closest( '.produkt-v2__logos-wrap' ).length ) {
			var $wrapper = $swiper.find( '.swiper-wrapper' );
			$wrapper.append( $wrapper.html() );
			return;
		}

		new Swiper( this, {
			slidesPerView: 2,
			spaceBetween: 16,
			loop: true,
			navigation: {
				prevEl: $swiper.find( '.swiper-button-prev' )[ 0 ],
				nextEl: $swiper.find( '.swiper-button-next' )[ 0 ],
			},
			breakpoints: {
				400: { slidesPerView: 3 },
			},
		} );
	} );

	// ── Benefits "show all" link ──────────────────────────────────────────────

	if ( $( '.product-benefits ul li' ).length <= 3 ) {
		$( '.all-bene, .product-benefits__more' ).hide();
	}

	// ── Tab switching ─────────────────────────────────────────────────────────
	// Staré (živé) .tabs/.single-tab a nové (admin-only) .produkt-v2__tabs-list/
	// .produkt-v2__tab jsou schválně oddělené třídy — nový design tak nezávisí
	// na single-produkt.scss (starém, sdíleném souboru), jen na téhle sdílené JS.

	function activateTab( tabName ) {
		var $tabsWrap = $( '#product-tabs' );
		var alreadyActive = $tabsWrap.find( 'ul.tabs li[data-tab="' + tabName + '"], .produkt-v2__tabs-list li[data-tab="' + tabName + '"]' ).hasClass( 'active' );

		$( '#product-tabs ul.tabs li, #product-tabs .produkt-v2__tabs-list li' ).removeClass( 'active' );
		$( '.single-tab, .produkt-v2__tab' ).removeClass( 'active' );
		$( '#product-tabs ul.tabs li[data-tab="' + tabName + '"], #product-tabs .produkt-v2__tabs-list li[data-tab="' + tabName + '"]' ).addClass( 'active' );
		$( '.single-tab.' + tabName + ', .produkt-v2__tab.' + tabName ).addClass( 'active' );

		// GA4/GTM: záložka se reálně přepnula (ne re-klik na už aktivní).
		if ( ! alreadyActive ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				event: 'product_tab_view',
				tab: tabName,
				product_id: $tabsWrap.data( 'product-id' ) || '',
				product_name: $tabsWrap.data( 'product-name' ) || ''
			} );
		}
	}

	$( '#product-tabs ul.tabs li, #product-tabs .produkt-v2__tabs-list li' ).on( 'click', function () {
		activateTab( $( this ).data( 'tab' ) );
	} );

	$( '.product-desc-tabs li.clickable' ).on( 'click', function () {
		var tab = $( this ).data( 'tab' );
		activateTab( tab );
		$( 'html, body' ).animate(
			{ scrollTop: $( '#product-tabs' ).offset().top },
			500
		);
	} );

	$( '.product-desc-tabs li[data-target="product-documents"]' ).on( 'click', function () {
		$( 'html, body' ).animate(
			{ scrollTop: $( '#documents' ).offset().top },
			500
		);
	} );

	$( '.all-bene, .product-benefits__more' ).on( 'click', function () {
		activateTab( 'benefits' );
		$( 'html, body' ).animate(
			{ scrollTop: $( '#product-tabs' ).offset().top },
			500
		);
	} );

	// ── Popis produktu (nový design, admin-only) — "Zobrazit více" ────────────
	// Třída existuje jen v admin markupu (single-produkt.php), pro běžné
	// návštěvníky je tenhle selektor prázdný a nic se nestane.
	// Místo rozbalování textu na místě odskočí na tab "Popis a výhody"
	// (stejný vzor jako .produkt-v2__benefits-more níž).

	$( '.produkt-v2__desc-toggle' ).on( 'click', function () {
		activateTab( 'benefits' );
		$( 'html, body' ).animate(
			{ scrollTop: $( '#product-tabs' ).offset().top },
			500
		);
	} );

	// ── Výhody produktu (nový design, admin-only) — "Zobrazit všechny výhody" ─
	// Stejné chování jako staré .all-bene/.product-benefits__more (activateTab +
	// scroll na #product-tabs), jen bez sdíleného selektoru, aby se do toho
	// netrefila hide-podmínka o pár řádků výš (ta cílí jen na starý .product-benefits).

	$( '.produkt-v2__benefits-more' ).on( 'click', function () {
		activateTab( 'benefits' );
		$( 'html, body' ).animate(
			{ scrollTop: $( '#product-tabs' ).offset().top },
			500
		);
	} );

})(jQuery);
